import React from 'react';

const STEPS = [
  { id: 'course_stage_start', label: 'Worker started' },
  { id: 'course_stage_variables_ready', label: 'Variables ready' },
  { id: 'course_stage_prompt_rendered', label: 'Prompt rendered' },
  { id: 'course_stage_llm_call_start', label: 'Calling model' },
  { id: 'course_stage_save_start', label: 'Saving output' },
  { id: 'course_stage_done', label: 'Completed' },
];

export function LessonRunProgress({ jobStatus, jobProgress }: { jobStatus: string | null; jobProgress: any[] }) {
  if (!jobStatus && (!jobProgress || jobProgress.length === 0)) return null;
  const events = new Set((jobProgress || []).map((p: any) => p?.event).filter(Boolean));
  const lastEvent = jobProgress?.length ? jobProgress[jobProgress.length - 1]?.event : null;
  return (
    <div className="mt-2 rounded border bg-gray-50 px-3 py-2 text-xs text-gray-700">
      <div className="flex items-center justify-between">
        <div>Run status: {jobStatus || 'unknown'}</div>
        {lastEvent && <div className="text-gray-500">Last: {lastEvent}</div>}
      </div>
      <div className="mt-2 grid grid-cols-2 gap-x-4 gap-y-1">
        {STEPS.map(step => {
          const done = events.has(step.id);
          return (
            <div key={step.id} className={`flex items-center gap-2 ${done ? 'text-green-700' : 'text-gray-500'}`}>
              <span>{done ? '✓' : '•'}</span>
              <span>{step.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
